import React from 'react';
import {
    Row,
    Col,
    Card
} from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { useTranslation, Trans } from 'react-i18next';
import { DashboardOutlined } from '@material-ui/icons';
import MasterPage from 'components/MasterPage';

const DashboardDiretor = () => {
    const { t } = useTranslation();

    const columns = [
        {
            dataField: 'period',
            text: 'Period',
            formatter: (cell) =>
                cell.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            headerStyle: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
        },
        {
            dataField: 'revenueBilled',
            text: 'Revenue Billed',
            formatter: (cell) =>
                cell.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            headerStyle: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
        },
        {
            dataField: 'revenueToBill',
            text: 'Revenue To Bill',
            formatter: (cell) =>
                cell.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            headerStyle: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
        },
        {
            dataField: 'costAccrued',
            text: 'Cost Accrued',
            formatter: (cell) =>
                cell.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            headerStyle: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
        },
        {
            dataField: 'costAccruedNotRefundable',
            text: 'Cost Accrued Not Refundable',
            formatter: (cell) =>
                cell.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            headerStyle: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
        },
        {
            dataField: 'costForecast',
            text: 'Cost Forecast',
            formatter: (cell) =>
                cell.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            headerStyle: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
        },
        {
            dataField: 'pisCofins',
            text: 'PIS/COFINS',
            formatter: (cell) =>
                cell.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            headerStyle: {
                textAlign: 'center',
                verticalAlign: 'middle'
            },
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
        },
        {
            dataField: 'aging',
            text: 'Aging',
            formatter: (cell) =>
                cell.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            headerStyle: {
                textAlign: 'center',
                verticalAlign: 'middle'
            },
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
        },
        {
            dataField: 'eliteProvisioning',
            text: 'Elite Provisioning (MKT)',
            formatter: (cell) =>
                cell.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            headerStyle: {
                textAlign: 'center',
                verticalAlign: 'middle'
            },
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
        },
        {
            dataField: 'elitePayment',
            text: 'Elite Payment',
            formatter: (cell) =>
                cell.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            headerStyle: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
        },
        {
            dataField: 'results',
            text: 'Results',
            formatter: (cell) =>
                cell.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            headerStyle: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
            style: {
                textAlign: 'center',
                verticalAlign: 'middle',
            },
        },
    ];

    var data = [{
        id: 1,
        period: "Jul/19",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 2,
        period: "Ago/19",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 3,
        period: "Set/19",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 4,
        period: "Out/19",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 5,
        period: "Nov/19",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 6,
        period: "Dec/19",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 7,
        period: "Jan/20",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 8,
        period: "Fev/20",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 9,
        period: "Mar/20",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 10,
        period: "Abr/20",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 11,
        period: "Mai/20",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 12,
        period: "Jun/20",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    }, {
        id: 13,
        period: "Total (R$)",
        revenueBilled: 0.00,
        revenueToBill: 0.00,
        costAccrued: 0.00,
        costAccruedNotRefundable: 0.00,
        costForecast: 0.00,
        pisCofins: 0.00,
        aging: 0.00,
        eliteProvisioning: 0.00,
        elitePayment: 0.00,
        results: 0.00
    },];

    return (
        <>
            <Row>
                <Col className="d-flex mt-3 mb-3">
                    <DashboardOutlined className="icon-title" />
                    <h4 className="title-dashboard mt-2">{t('title:dashboard')}</h4>
                </Col>
            </Row>
            <Card.Body
                style={{ marginBottom: '10px' }}
                className="shadow bg-white rounded"
            >
                <Row>
                    <Col>
                        <BootstrapTable
                            responsive
                            keyField="id"
                            data={data}
                            columns={columns}
                            wrapperClasses="table-responsive"
                        />
                    </Col>
                </Row>
            </Card.Body>
        </>
    );
};

export default DashboardDiretor;
